import React, { FC } from 'react';
import styled from 'styled-components';
import { ReactComponent as FormTemplateIconSvg } from 'assets/svgs/form-instance-icon.svg';
import { BodyShort01, SingleLineEllipsis, Text02 } from 'components/styles';
import { Task } from 'data/tasks';
// eslint-disable-next-line import/no-internal-modules
import { getDisplayTaskName } from '../task-card-new/utils';

const Title = styled.div`
  ${BodyShort01};
  ${Text02};
  flex: 1;
  ${SingleLineEllipsis};
`;

export const TaskCardTitle: FC<{
  task: Task;
}> = ({ task }) => <Title>{getDisplayTaskName(task, 2)}</Title>;

const CompletedTaskTitle = styled(Title)`
  max-width: 160px;
  display: flex;
  gap: var(--spacing-02);
`;

const FormInstanceIconWrapper = styled.div`
  margin-top: 1px;
`;

export const CompletedTaskCardTitle: FC<{
  task: Task;
  rows?: number;
}> = ({ task, rows = 2 }) => (
  <CompletedTaskTitle>
    {task.formInstanceId && (
      <FormInstanceIconWrapper>
        <FormTemplateIconSvg />
      </FormInstanceIconWrapper>
    )}
    {getDisplayTaskName(task, rows)}
  </CompletedTaskTitle>
);
